import React, { useEffect, useRef } from 'react'

/**
 * @param ref HTMLElement to check 
 * @param callback A callback that is called when clicking outside `ref`. Its identity must be stable.
 */
export function useClickOutside (ref: React.MutableRefObject<HTMLElement>, callback: () => void, { active, stopPropagation = true }: { active: boolean, stopPropagation?: boolean }) {
  const activeRef = useRef(active)
  activeRef.current = active

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (activeRef.current && ref.current && !ref.current.contains(event.target as Node)) {
        callback()

        if (stopPropagation) {
          event.preventDefault()
          event.stopPropagation()
        }
      }
    }
      
    document.addEventListener('click', handleClickOutside, true)
    return () => document.removeEventListener('click', handleClickOutside, true)
  }, [callback, ref, stopPropagation])
}
